/**
 * Days after creation that uploads and generations are deleted by the storage
 * cleanup job. Keep in step with that job: every user-facing mention of the
 * retention window (banner, FAQ, privacy policy) reads from here.
 */
export const RETENTION_DAYS = 14;

/** "14 days", with a non-breaking space so the number never wraps away from its unit. */
export const RETENTION_LABEL = `${RETENTION_DAYS} days`;

/** True once a run is past the retention window, so its files are already gone from storage. */
export function isExpired(createdAt: string, now = Date.now()): boolean {
  return now - new Date(createdAt).getTime() > RETENTION_DAYS * 24 * 60 * 60 * 1000;
}

/**
 * True for a finished run whose files the clean-up has deleted. Failed and
 * pending runs never stored anything, so they keep showing as they are.
 */
export function hasExpiredFiles(run: { status: string; created_at: string }, now = Date.now()): boolean {
  return run.status === "completed" && isExpired(run.created_at, now);
}
